
import * as ipxStaticRuntime$PVzsadhPovw_L86dYOQ5FVs37dOHxluy5ZKeyzMZI94 from '/opt/buildhome/repo/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@9.1.2_db0@0.3.2_ioredis@5.8.0_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$PVzsadhPovw_L86dYOQ5FVs37dOHxluy5ZKeyzMZI94, defaults: {} }
}
        